import { Observable } from "@babylonjs/core/Misc/observable";

/**
 * Récolte de la partie : le nombre d'arbres abattus.
 *
 * C'est le pendant de l'`InputManager`, dans l'autre sens : celui-ci porte ce
 * que la scène reçoit du joueur, celui-là ce qu'elle lui renvoie. Le détour par
 * un objet commun évite deux dépendances qu'on ne voudrait ni l'une ni l'autre —
 * un HUD qui devrait retrouver la scène après chaque transition, et une scène
 * qui toucherait au DOM, ce qu'elle ne peut de toute façon pas faire sous
 * `NullEngine`.
 *
 * Le total est notifié plutôt qu'interrogé à chaque image : la jauge ne se
 * redessine qu'aux rares images où un arbre tombe.
 */
export class Harvest {
  /** Émis à chaque changement, avec le total courant. */
  readonly onChanged = new Observable<number>();

  private total = 0;

  /** Arbres abattus depuis le début de la partie. */
  get count(): number {
    return this.total;
  }

  /** Ajoute des arbres au compteur. Une quantité nulle ou négative est ignorée. */
  add(trees = 1): void {
    if (trees <= 0) return;

    this.total += trees;
    this.onChanged.notifyObservers(this.total);
  }

  /** Repart de zéro (nouvelle partie). Silencieux si le compteur l'est déjà. */
  reset(): void {
    if (this.total === 0) return;

    this.total = 0;
    this.onChanged.notifyObservers(this.total);
  }

  dispose(): void {
    this.onChanged.clear();
  }
}
